import { PluginListenerHandle } from '@capacitor/core';
import {
  onMounted, onUnmounted, Ref, ref,
} from 'vue';
import { storeToRefs } from 'pinia';
import { useMainStore } from '@/core/store/main';
import { Maybe } from '@/shared/types';
import { useRouter } from 'vue-router';
import { App } from '@capacitor/app';
import { logAnalyticsEvent } from '@/core/analytics/analytics';
import { AnalyticsEventName } from '@/core/analytics/types';

export const useLogAppEventAnaliytics = () => {
  const router = useRouter();

  const listener: Ref<Maybe<PluginListenerHandle>> = ref();

  const { activeScreen } = storeToRefs(useMainStore());

  /**
 * Logs an event to Google Analytics when the app is sent to the background.
 *
 * This function is called when the user navigates away from the app.
 * It logs the current app section being viewed.
 *
 * @returns {Promise<void>} A promise that resolves when the event is logged.
 */
  const logAppToBackground = async () => {
    await logAnalyticsEvent({
      name: AnalyticsEventName.AppBackground,
      params: {
        appSection: activeScreen.value,
        appRoute: router.currentRoute.value.path,
      },
    });
  };

  onMounted(async () => {
    listener.value = await App.addListener('pause', async () => {
      await logAppToBackground();
    });
  });

  onUnmounted(() => {
    if (listener.value) {
      listener.value.remove();
    }
  });

  return {
  };
};
